import { render, staticRenderFns } from "./editColor.vue?vue&type=template&id=88ee186a&"
import script from "./editColor.vue?vue&type=script&lang=js&"
export * from "./editColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports